/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCapRounded = createReactComponent("outline", "cap-rounded", "IconCapRounded", [["path", { "d": "M20 6h-9a6 6 0 1 0 0 12h9", "key": "svg-0" }], ["path", { "d": "M13 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0", "key": "svg-1" }], ["path", { "d": "M13 12h7", "key": "svg-2" }]]);

export { IconCapRounded as default };
//# sourceMappingURL=IconCapRounded.mjs.map
